import { RTTaskIO } from "../../components/RTTaskIO/RTTaskIO"
import dtTaskDataInitial from './data/dtTaskData.js';
import rtTaskDataInitial from './data/rtTaskData.js';
import { fetchRtTask, fetchDtTask } from "./api.js";
import { useEffect, useState } from "react";
import { useParams } from "react-router-dom";


const RTTaskIOPage = () => {
  // fetch task data from API
  const { id: TASK_ID } = useParams();
  const [rtTaskData, setRTTaskData] = useState(null)//useState(rtTaskDataInitial);
  const [dtTaskData, setDTTaskData] = useState(null)//useState(dtTaskDataInitial);
  
  useEffect(() => {
    fetchRtTask(TASK_ID).then(fetchedRtTaskData => {
      if (fetchedRtTaskData.error){
        console.error(fetchedRtTaskData.error);
        return;
      }
      fetchedRtTaskData = fetchedRtTaskData.result;
      setRTTaskData(fetchedRtTaskData);
      const dtTaskId = fetchedRtTaskData.DT_taskId;
      fetchDtTask(dtTaskId).then(fetchedDtTaskData => {
        if(fetchedDtTaskData.error){
          console.error(fetchedDtTaskData.error);
          return;
        }
        fetchedDtTaskData = fetchedDtTaskData.result;
        setDTTaskData(fetchedDtTaskData);
      });
    });
  }, []);

  if(!rtTaskData || !dtTaskData){
    return <div>Loading...</div>
  }
  return (
    <RTTaskIO 
      rtTaskData={rtTaskData}
      dtTaskData={dtTaskData}
    />
  )
}

export default RTTaskIOPage;